import type { AuditLineItemV5, ChangeLogUnionObject, DayPartV5 } from '../../../apis/graphql';
import { formatTimeDetail } from '../../../utils/formatting';
import type { ChangeLogEntryNode, UseChangeLogListProps, UseChangeLogListResponse } from './types';
import { getNormalizedChanges } from './utils';

export const useChangeLogList = ({
  changeLogEntries,
  nestedChangesPrefix,
  targetingChangesList,
  entityType,
}: UseChangeLogListProps): UseChangeLogListResponse => {
  let previousDayPartList: DayPartV5[] | null;
  let previousObject: ChangeLogUnionObject | null;

  const filteredChangeLogList = changeLogEntries.map(({ node }: ChangeLogEntryNode, index: number) => {
    const targetingChanges = targetingChangesList?.length ? targetingChangesList[index] : undefined;

    if (changeLogEntries[index + 1]) {
      const previousDayPart = (changeLogEntries[index + 1].node.audits.object as AuditLineItemV5)?.schedule
        ?.dayPartList;
      previousObject = changeLogEntries[index + 1].node.audits.object;

      // we need to check for null, because this means that all values in the schedule have been deleted
      if (previousDayPart || previousDayPart === null) {
        previousDayPartList = previousDayPart || [];
      }
    } else {
      previousDayPartList = [];
      previousObject = null;
    }

    const {
      audits: { modifiedBy, modifiedDate },
      creativeAudits: creativeAuditsFromNode,
    } = node;

    const { creativeAudits, audits } = getNormalizedChanges({
      previousObject,
      nestedChangesPrefix,
      previousDayPartList,
      node,
      entityType,
      targetingChanges,
    });

    const dateFormat = formatTimeDetail(modifiedDate);
    const creativeDateFormat = formatTimeDetail(
      creativeAuditsFromNode.length > 0 ? creativeAuditsFromNode[0].modifiedDate : null
    );
    const creativeModifiedBy = creativeAuditsFromNode.length > 0 ? creativeAuditsFromNode[0].modifiedBy : '';

    return {
      creativeAudits,
      audits,
      dateFormat,
      creativeDateFormat,
      creativeModifiedBy,
      modifiedBy,
      originalIndex: index,
      targetingChanges,
    };
  });

  const filteredChangeLogListWithChanges = filteredChangeLogList.filter((log) => log.audits.changesLength);

  return { filteredChangeLogList: filteredChangeLogListWithChanges };
};
